import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 出入金約定與其他財力證明 ViewData
 */
const FillBasicDataViewData = [
    'POST',
    RouteUrlList.API_FillBasicDataViewData.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        result: {
            cname: '測試姓名',
            birthday: '19900101',
            ssn: 'A123456789',
            sex: '',
            education: '',
            educationOther: '',
            isLockIDCheck: false,
            iDCheck_P_Collection: [{ enum_id: '1', enum_nm: '北市' }],
            iDCheck_T_Collection: [{ name: '初發', value: '1' }],
            iDCheck_Y_Collection: ['1990', '1991', '1992'],
            iDCheck_M_Collection: ['01', '02', '03'],
            iDCheck_D_Collection: ['01', '02', '03'],

            iDCheck_P: '',
            iDCheck_T: '',
            iDCheck_Y: '',
            iDCheck_M: '',
            iDCheck_D: '',

            countryOfBirthList: [{ countrycode: 'TW', countrytitle: '中華民國(台澎金馬地區)' }],

            commonCityData: [
                { city: '台北市', sequence: '1' },
                { city: '新北市', sequence: '2' }
            ],

            domicileCode: '100',
            domicileAddressCity: '台北市',
            domicileAddressDist: '中正區',
            domicileAddressRoad: '中山南路1號',

            mailingAddressCode: '',
            mailingAddressCity: '',
            mailingAddressDist: '',
            mailingAddressRoad: '',

            homeAddressCode: '',
            homeAddressCity: '',
            homeAddressDist: '',
            homeAddressRoad: '',

            contactExt: '',
            contactTelephone: '02-',
            emergencyContactRelation: '其他',
            emergencyContactRelationOther: '123',
            emergencyContact: '',
            emergencyContactPhone: '',
            mobilephone: '',
            mobilephoneOtpBaseData: {
                isVerified: false,
                isInSendStatus: false,
                isInWaitToSendAgain: false,
                timeCountSec: 300,
                nowLeftSec: 300,
                sendCount: 0,
                verifySendCount: 0,
                codeLetter: '',
                inSendIntervalMessage: '',
                reachedVerifyMaxTryMessage: ''
            },
            email: 'test@example.com',
            emailOtpBaseData: {
                isVerified: false,
                isInSendStatus: false,
                isInWaitToSendAgain: false,
                timeCountSec: 300,
                nowLeftSec: 299,
                sendCount: 0,
                verifySendCount: 0,
                codeLetter: 'ATT',
                inSendIntervalMessage: '',
                reachedVerifyMaxTryMessage: ''
            }
        }
    }
];
export default FillBasicDataViewData;
